Vue.component('filter-slider', require('./slider.vue').default)
Vue.component('filter-switch', require('./switch.vue').default)
Vue.component('filter-txtarea', require('./textarea.vue').default)

new Vue({
    el: '#filter-components',

    methods: {
        reset() {
            // future TODO reset event call passed on to vue-components
            console.log("in vuejs reset")
        }
    }
})
